const locationFacilityTypes = {
  create: 'Crear',
  update: 'Actualizar',
  facilityType: {
    school: 'Escuela',
    work: 'Lugar de trabajo',
  },
  toasts: {
    delete: {
      success: '[Location Facility] se eliminó correctamente',
      errorMessage: 'Algo salió mal. Inténtalo de nuevo más tarde.',
    },
    create: {
      success: '[Location Facility] se creó correctamente',
      error: '[Location Facility] respuesta incorrecta del servidor',
    },
    update: {
      success: '[Location Facility] se actualizó correctamente',
      error: '[Location Facility] respuesta incorrecta del servidor',
    },
  },
  deleteModal: {
    header: 'Eliminar instalaciones',
    body: '¿Seguro que deseas eliminar {{num}} instalaciones?',
  },
  table: {
    headers: {
      name: 'Nombre',
      type: 'Tipo',
      facilityTypes: 'Tipo',
      contactName: 'Сontacto',
      email: 'Correo electrónico',
      phone: 'Número de teléfono',
      address: 'Dirección',
      profile: 'Perfil',
    },
    filters: {
      type: 'Tipo',
    },
    actions: {
      delete: 'Eliminar',
    },
  },
  form: {
    tabs: {
      general: 'Info de ubicación',
      contact: 'Info de contacto',
      hours: 'Horarios',
      advancedSettings: 'Preferencias',
      holidays: 'Feriados',
    },
    forms: {
      general: {
        header: 'Ubicación {{type}}',
        fields: {
          name: 'Nombre de {{type}}',
          address: 'Dirección de {{type}}',
          type: 'Tipo de instalación',
          radius: {
            title: 'Radio de coincidencia de dirección',
            description:
              'El radio en metros o pies (m/ft para métrico/imperial) dentro del cual las reservas se reconocen como la ubicación y/o como espera y regreso.',
          },
        },
      },
      contacts: {
        header: 'Contacto: {{index}}',
        fields: {
          comment: 'Comentario',
          address: 'Dirección',
          fax: 'Fax',
          phone: 'Teléfono',
          email: 'Correo electrónico',
          type: 'Tipo',
          name: 'Nombre',
        },
        actions: {
          add: 'Agregar contacto +',
        },
      },
      shiftsHours: {
        header: {
          school: 'Horario escolar',
          work: 'Horario laboral',
        },
        fields: {
          name: 'Nombre',
          status: 'Estado',
          start: 'Inicio',
          end: 'Fin',
          type: {
            title: 'Tipo',
            options: {
              collect: 'Recoger',
              distribute: 'Distribuir',
              both: 'Ambos',
            },
          },
          weekDays: 'Días de la semana',
        },
        actions: {
          add: {
            default: '+ Agregar',
            school: '+ Agregar horario escolar',
            work: '+ Agregar horario laboral',
          },
        },
      },
      reservationPreferences: {
        header: 'Preferencias de reserva',
        fields: {
          sharedWithOther: 'Compartido con otros',
          profile: 'Perfil',
          suppliers: 'Proveedores',
          service: 'Servicio',
        },
      },
      advancedSettings: {
        header: 'Configuración avanzada',
        fields: {
          consistentPassengerRouting: {
            title: 'Enrutamiento consistente de pasajeros',
            toolTipInformation:
              'Garantiza que el mismo grupo de pasajeros siempre siga la misma ruta hacia y desde la instalación, optimizando la eficiencia del viaje y minimizando la confusión.',
          },
          sameDriverForGroup: {
            title: 'Mismo conductor para el grupo',
            toolTipInformation:
              'Asigna el mismo conductor para transportar al grupo de pasajeros tanto en la recogida como en el descenso, brindando familiaridad y consistencia a los pasajeros.',
          },
          allowSharedRide: {
            title: 'Permitir viaje compartido con otras direcciones',
            toolTipInformation:
              'Cuando está habilitado, esta configuración permite que los viajes compartidos se agrupen con reservas de otras ubicaciones que tengan rutas consistentes. Si está deshabilitado, solo se considerarán para agrupar los viajes de la misma ubicación.',
          },
          tripBoardingTime: {
            title: 'Tiempo de abordaje',
            toolTipInformation:
              'El tiempo que se tarda en recoger a un pasajero en su parada (Este parámetro afectará la duración total del viaje)',
          },
          waitForBoardingTime: {
            title: 'Tiempo de espera para abordaje',
            toolTipInformation: 'Al llegar a una parada, el conductor esperará hasta la hora exacta de recogida, si es necesario.',
          },
          tripDropOffTime: {
            title: 'Tiempo de descenso',
            toolTipInformation:
              'El tiempo que se tarda en dejar a un pasajero en su parada (Este parámetro afectará la duración total del viaje)',
          },
          rules: {
            header: 'Reglas de ubicación / perfiles',
            rule: 'Regla',
            profiles: 'Perfiles',
            addNewRule: '+ Agregar regla de ubicación / perfil',
          },
          maxDropOffEarly: {
            title: 'Máximo adelanto en descenso',
            toolTipInformation:
              'Número máximo de minutos que un conductor puede llegar antes respecto a la hora de descenso establecida en la reserva',
          },
          maxDropOffDelay: {
            title: 'Máximo retraso en descenso',
            toolTipInformation:
              'Número máximo de minutos que un conductor puede llegar tarde respecto a la hora de descenso establecida en la reserva',
          },
          maxBoardingDelay: {
            title: 'Máximo retraso en recogida',
            toolTipInformation:
              'Número máximo de minutos que un conductor puede llegar tarde respecto a la hora de recogida establecida en la reserva',
          },
          maxBoardingEarly: {
            title: 'Máximo adelanto en recogida',
            toolTipInformation:
              'Número máximo de minutos que un conductor puede llegar antes respecto a la hora de recogida establecida en la reserva',
          },
          maxTripDuration: {
            title: 'Duración máxima del viaje',
            toolTipInformation: 'Duración máxima de un viaje en minutos',
          },
          maxSinglePassengerTime: {
            title: 'Duración máxima del viaje por pasajero',
            toolTipInformation: 'Duración máxima de un viaje en minutos por pasajero',
          },
        },
      },
      excludedDrivers: {
        header: 'Conductores excluidos',
        fields: {
          driversList: 'Lista de conductores',
          excludedList: 'Lista de excluidos',
        },
      },
      excludedVehicles: {
        header: 'Vehículos excluidos',
        fields: {
          vehiclesList: 'Lista de vehículos',
          excludedList: 'Lista de excluidos',
        },
      },
      excludeHolidays: {
        header: 'Feriados excluidos',
        fields: {
          holidaysList: 'Lista de feriados',
          excludedList: 'Feriados excluidos',
        },
      },
    },
  },
};

export default locationFacilityTypes;
